/**
 * /admins — platform-scoped route shim.
 */

import { createFileRoute, Link } from "@tanstack/react-router";
import { fetchAdmins, scopeKey } from "@/features/platform-admins/queries";
import { queryKeys } from "@/lib/query-keys";
import { AdminsPage } from "@/features/platform-admins/pages/platform-admins-page";

function PlatformAdminsRoute() {
  return (
    <AdminsPage
      tenantID={null}
      scope="platform"
      title="Platform admins"
      description="Operators with access to the PureID control plane."
      breadcrumbs={[{ label: "Admins" }]}
      renderInviteLink={({ children, className }) => (
        <Link to="/admins/invite" className={className}>
          {children}
        </Link>
      )}
    />
  );
}

export const Route = createFileRoute("/_authed/admins/")({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.adminUsers.list(scopeKey(null)),
      queryFn: () => fetchAdmins(null),
    }),
  component: PlatformAdminsRoute,
});
